import { Card, Chip, Tooltip } from '@mui/material';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors';
import { BackMobileIcon, CancelIcon, CancelWhiteIcon, ChatSummaryIcon, DisabledGridIcon, FalkonAiWhiteIcon, MessageDeliveredIcon } from '../../icon';
import Avatar from '../shared/avatar.component';
import { ChannelContactServices } from '../../services/channels/ChannelContactService';
import { ChannelUserService } from '../../services/ChannelUserService';
import { ChannelContactModel, ChannelMessageItem, mapToChannelContactItem } from '../../models/conversations';
import { UtilityService } from '../../services/UtilityService';
import ButtonComponent from '../shared/button/button.component';
import xlsx from 'json-as-xlsx';
import { ChannelAiService } from '../../services/channels/ChannelAiService';



interface Props {
    CardTitle: string;
    ActionsData: any;
    CloseContactInfo: () => void;
    OnlineStatus: boolean;
    Name: string;
    ParticipantID: string;
    PageName: string;
    ChannelType?: number;
}

const ContactInfoComponent = (props: Props) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const ChannelHistory = useSelector(selector.ChannelHistory)
    const AiFeatures: boolean = useSelector(selector.AiFeatures)

    const [contact, SetContact] = useState<ChannelContactModel>()
    const [showChatSummary, setShowChatSummary] = useState<boolean>(false)
    const [sentiment, setSentiment] = useState<string>("")
    const [summary, setSummary] = useState<string>("")
    const [loader, setLoader] = useState<boolean>(false)
    const [ButtonName, setbuttonName] = useState<string>("Generate chat summary")

    useLayoutEffect(() => {
        ChannelContactServices.getChannelContactByID(ChannelUserService.getCurrentUserFromLocalStorage()?.OrganizationID, props.ParticipantID).then((res) => {
            // console.log(ChannelHistory[props.ParticipantID]?.filter(x => x.MessageType === "text").map(z => { return  `${z.IsOutbound ? ChannelUserService.getCurrentUserFromLocalStorage()?.FirstName : props.Name} : ${z.Message}` }))
            SetContact(mapToChannelContactItem(res.data))
        })
            .catch((err) => { })
        if (AiFeatures) {
            ChannelAiService.getLastGeneratedChatSummaryandSentimentByParticipantId(props.ParticipantID).then((res) => {
                setSentiment(res.data.sentiment)
                setSummary(res.data.summary)
                setbuttonName(res.data.sentiment === "Not yet available" ? "Generate chat summary" : "Generate chat summary Again")
            }).catch((err) => {
                setSentiment("No Sentiment")
                setSummary(err.response?.data.error || "No Chat Summary")
                setbuttonName("Generate chat summary")
            })
        }
    }, [])


    const handleGenerateSummary = () => {
        setLoader(true)
        const HistorytoFeed = ChannelHistory[props.ParticipantID]?.filter(x => x.MessageType === "text").map(z => { return `${z.IsOutbound ? " Agent" : " Customer"} : ${z.Message}` })

        if (!HistorytoFeed.length) {
            setShowChatSummary(true)
            setSentiment("No Sentiment")
            setSummary("No Messages")
            setLoader(false)
        }
        else {
            ChannelAiService.getChatSummaryandSentiment({ text: HistorytoFeed.join(""), channel: props.ChannelType, contact: props.ParticipantID }).then(res => {
                setSentiment(res.data.sentiment)
                setSummary(res.data.summary)
                setShowChatSummary(true)
                setLoader(false)
            }).catch(() => {
                props.CloseContactInfo()
            })
        }

    }

    return (
        <div className={`bg-color-secondary contact-info-card-container d-flex h-p-100 ${IsMobileDevice ? "w-p-100" : "br-2 max-w-40 min-w-40"}`} style={{ boxShadow: IsMobileDevice ? "none " : "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)" }}>
            {contact &&
                <div className={`w-p-100 h-p-100`}>
                    <div className='w-p-100 h-p-100 pb-2'>
                        <div className={`d-flex w-p-100 ${IsMobileDevice ? "bg-color-secondary box-shadow-display-background-shadow bb-primary-divider-4 align-center" : "bg-color-primary-light brt-2 h-p-20 py-1 my-auto "}`}>
                            <div className={`${IsMobileDevice ? "h3 f-label-input" : "h4-regular color-secondary"} h4-regular d-flex align-center pl-1`}>
                                {IsMobileDevice && <BackMobileIcon onClick={props.CloseContactInfo} className={"c-pointer mr-1 my-auto py-2"} />}
                                <span className="">{props.CardTitle}</span>
                            </div>
                            {!IsMobileDevice && <Tooltip title='Close' placement='bottom'>
                                <CancelWhiteIcon className="c-pointer ml-auto my-auto pr-1" tabIndex={2} onClick={props.CloseContactInfo} />
                            </Tooltip>}
                        </div>
                        <div className={`w-p-100 ${IsMobileDevice ? "h-p-90" : "h-p-80 max-h-60"} d-flex align-center bg-color-secondary flex-direction o-y-scroll`}>
                            <div style={{ boxShadow: "0px 10px 15px #7090B033" }} className='w-p-80 my-5 py-2 t-align-center bg-color-secondary br-3'>
                                <div className=' d-flex align-center justify-center br-3'>
                                    <Avatar Name={props.Name} Size={60} />
                                </div>
                                <div className='h2-semibold color-primary-accent t-align-center py-1'>
                                    {UtilityService.trimMessage(props.Name, 20)}
                                </div>
                                {props.OnlineStatus ?
                                    <div className=' br-2 mx-auto d-flex align-center color-channel-history-header h5-medium justify-center'>
                                        <MessageDeliveredIcon className={"mr-1"} />
                                        Online
                                    </div>
                                    :
                                    <div className=' br-2 mx-auto d-flex align-center color-channel-history-header h5-medium justify-center'>
                                        <DisabledGridIcon className={"mr-1"} />
                                        Offline
                                    </div>
                                }
                            </div>
                            <div className='w-p-80 t-align-center m-auto bg-color-secondary h5-medium'>
                                <div className='d-flex w-p-100 h-4'>
                                    <div className='w-p-50 d-flex justify-flex-start align-center color-text-field-label'>
                                        Email
                                    </div>
                                    <div className='w-p-50 d-flex justify-flex-start align-center'>
                                        {!!contact?.Email ? UtilityService.trimMessage(contact?.Email, 18) : "--"}
                                    </div>
                                </div>

                                <div className='d-flex w-p-100 h-4'>
                                    <div className='w-p-50 d-flex justify-flex-start align-center color-text-field-label'>
                                        Page Name
                                    </div>
                                    <div className='w-p-50 d-flex justify-flex-start align-center'>
                                        {UtilityService.trimMessage(props.PageName, 22)}
                                    </div>
                                </div>

                                <div className='d-flex w-p-100 h-4'>
                                    <div className='w-p-50 d-flex justify-flex-start align-center color-text-field-label'>
                                        First Connected
                                    </div>
                                    <div className='w-p-50 d-flex justify-flex-start align-center'>
                                        {!!contact?.CreatedDateTime ? UtilityService.convertDateToDay(contact?.CreatedDateTime) : "--"}
                                    </div>
                                </div>

                                <div className='d-flex w-p-100 h-4'>
                                    <div className='w-p-50 d-flex justify-flex-start align-center color-text-field-label'>
                                        Last Connected
                                    </div>
                                    <div className='w-p-50 d-flex justify-flex-start align-center'>
                                        {!!contact?.UpdatedAt ? UtilityService.convertDateToDay(contact?.CreatedDateTime) : "--"}
                                    </div>
                                </div>

                                {!!contact?.CustomFields && contact?.CustomFields.map((x) => {
                                    return (
                                        <div className='d-flex w-p-100 h-4'>
                                            <div className='w-p-50 d-flex justify-flex-start align-center color-text-field-label'>
                                                {x?.Name}
                                            </div>
                                            <div className='w-p-50 d-flex justify-flex-start align-center'>
                                                {x?.Value ? UtilityService.trimMessage(x?.Value, 22) : "--"}
                                            </div>
                                        </div>
                                    )
                                })}
                                {AiFeatures &&
                                    <>
                                        <div className='w-p-100 d-flex h-4 '>
                                            <div className='w-p-50 d-flex justify-flex-start align-center color-text-field-label'>
                                                Customer Sentiment
                                            </div>
                                            <div className={`w-p-50 d-flex justify-flex-start align-center satisfaction-${sentiment}`}>
                                                {sentiment} {sentiment === "Frustrated" ? "😡" : sentiment === "Unhappy" ? "😞" : sentiment === "Neutral" ? "😐" : sentiment === "Happy" ? "🙂" : "😍"}
                                            </div>
                                        </div>
                                        <div className='w-p-100 h-2 mb-1'>
                                            <div className='w-p-50 d-flex justify-flex-start align-center color-text-field-label'>
                                                Chat Summary
                                            </div>
                                        </div>
                                        <div className='t-align-left bg-color-secondary h5-medium'>
                                            {summary}
                                        </div>
                                    </>
                                }
                            </div>
                            {AiFeatures &&
                                <ButtonComponent Loading={loader} ClassName='w-p-80' ButtonLabel={ButtonName} Variant={'ai-primary-btn'} Icon={FalkonAiWhiteIcon} OnClick={handleGenerateSummary} />
                            }
                        </div>
                    </div>

                    {/* {showChatSummary &&
                        <div className='w-p-100 h-p-100 contact-info-card-side contact-info-card-back py-1'>
                            <div className={`d-flex w-p-100 py-1 my-auto ${IsMobileDevice ? "bg-color-secondary box-shadow-display-background-shadow bb-primary-divider-4" : "brt-2 h-p-30"}`}>
                                <div className={`${IsMobileDevice ? "h3 f-label-input" : "h4-regular color-primary-accent"} h3-semibold d-flex align-center`}>
                                    {IsMobileDevice && <BackMobileIcon onClick={props.CloseContactInfo} className={"c-pointer mr-1 my-auto py-2"} />}
                                    <span className="pl-2 h-p-100 d-flex justify-center align-center">Falkon Ai Chat Summary <ChatSummaryIcon className='w-3 h-3 ml-1' /></span>
                                </div>
                                {!IsMobileDevice && <Tooltip title='Close' placement='bottom'>
                                    <CancelIcon className="c-pointer ml-auto my-auto pr-2" tabIndex={2} onClick={props.CloseContactInfo} />
                                </Tooltip>}
                            </div>
                            <div className={`bb-primary-divider-4 w-p-96 my-auto`}></div>
                            <div className='w-p-100 h-p-70 d-flex align-center justify-center bg-color-secondary flex-direction '>
                                <div className='w-p-100 h-p-30 my-2 d-flex align-center'>
                                    <div className='w-p-50 h-p-100 h4-medium pl-2'>
                                        customer sentiment :
                                    </div>
                                    <div className={`h-p-100 h5-medium satisfaction-${sentiment}`}>
                                        {sentiment} {sentiment === "Frustrated" ? "😡" : sentiment === "Unhappy" ? "😞" : sentiment === "Neutral" ? "😐" : sentiment === "Happy" ? "🙂" : "😍"}
                                    </div>
                                </div>
                                <div className='w-p-100 h-p-20 mb-1'>
                                    <div className='w-p-100 h-p-100 h4-medium pl-2'>
                                        chat summary :
                                    </div>
                                </div>
                                <div className=' px-2 h-p-60 m-auto bg-color-secondary h5-medium'>
                                    {summary}
                                </div>
                            </div>
                        </div>
                    } */}
                </div>
            }
        </div>
    )
}

export default ContactInfoComponent;